import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_throw_pillows: FaireCategoryEntity = {
  token: "catalog_cat_throw-pillows",
  type: "category",
  name: "Throw pillows & blankets",
  count: 410,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
